module.exports = __webpack_public_path__ + "static/media/btn_arrow.7ed0be9f.svg";